// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"32":"824a1c56","293":"39e15a4a","360":"52f068d8"}[chunkId] + ".chunk.css";
};